<template>
  <!-- ▼Main Container -->
  <div class="boss-main-container">
    <div class="boss-main-wrap boss-main-content-wrap pega-auto-reply-container">
      <setting-header
        :breadcrumbs="[{ name: '各種設定' }]"
        title="応募受付メッセージ自動送信 ／ 編集"
      />
      <div class="boss-layout-block margin-bottom-1">
        <ul
          id="boss-tab-menu"
          data-tabs
          class="tabs boss-tabs-menu-list"
        >
          <li
            :class="{ 'is-active': currentTabKey === 'selectionEntry' }"
            class="tabs-title"
            data-test="tab-selection-entry"
          >
            <a
              class="boss-tabs-link"
              data-test="link-selection-entry"
              @click="changeCurrent('selectionEntry')"
            >選考応募</a>
          </li>
          <li
            :class="{ 'is-active': currentTabKey === 'casualInterviewRequest' }"
            class="tabs-title"
            data-test="tab-casual-interview-request"
          >
            <a
              class="boss-tabs-link"
              data-test="link-casual-interview-request"
              @click="changeCurrent('casualInterviewRequest')"
            >話を聞きたい&nbsp;
              <span
                v-tooltip="{ content: '話を聞きたい応募（カジュアル面談）の応募受付メッセージを設定できます。話を聞きたい（カジュアル面談）の受付は掲載済みの求人・応募フォームタイプ設定から設定できます。'}"
                class="pega-circle"
              >?
              </span>
            </a>
          </li>
        </ul>
      </div>
      <div class="boss-layout-block">
        <keep-alive>
          <component
            :is="tabs[currentTabKey]"
            data-test="tab-content"
          />
        </keep-alive>
      </div>
    </div>
  </div>
</template>

<script>
import SettingHeader from '@/components/atoms/SettingHeader'
import SettingApplicantAutoReply from '@/components/organisms/SettingApplicantAutoReply'
import SettingCasualInterviewRequestAutoReply from '@/components/organisms/SettingCasualInterviewRequestAutoReply'

export default {
  components: {
    SettingHeader,
    SettingApplicantAutoReply,
    SettingCasualInterviewRequestAutoReply
  },
  data () {
    return {
      currentTabKey: 'selectionEntry',
      tabs: {
        selectionEntry: 'setting-applicant-auto-reply',
        casualInterviewRequest: 'setting-casual-interview-request-auto-reply'
      }
    }
  },
  methods: {
    changeCurrent (key) {
      this.$set(this, 'currentTabKey', key)
    }
  }
}
</script>
